import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";

import { docTypeSerializer } from "./anyDoc";

const indexerDtoSerializer = Serializers.object({
  docType: docTypeSerializer,
  indexVersionName: Serializers.string,
  indexAlias: Serializers.string,
  // mappings: Serializers.identity(),
  version: Serializers.string,
});

export type IndexerDto = SerializerValue<typeof indexerDtoSerializer>;

export const docExchangeStatusSerializer = Serializers.object({
  docType: docTypeSerializer,
  exchange: Serializers.string,
  hash: Serializers.string,
  writers: Serializers.string.array(),
  writerInitialized: Serializers.boolean,
  reader: Serializers.string,
  readerCursor: Serializers.integer.nullable(),
  latestWriterSequence: Serializers.integer.nullable(),
  readerLag: Serializers.integer.nullable(),
  indexAlias: Serializers.string,
  indexVersionName: Serializers.string,
  indexAliased: Serializers.boolean,
});

export type DocExchangeStatus = SerializerValue<typeof docExchangeStatusSerializer>;

export const indexModuleActions = {
  indexersQuery: HttpAction({
    path: "/indexers",
    valueSerializer: indexerDtoSerializer.array(),
    requiresAuth: true,
  }),
  docExchangeStatusQuery: HttpAction({
    path: "/debug/doc-exchanges",
    valueSerializer: docExchangeStatusSerializer.array(),
    requiresAuth: true,
  }),
  refreshIndexDocs: HttpAction({
    path: "/refreshDocs",
    method: "post",
    requiresAuth: true,
    qsSerializer: Serializers.object({
      module: docTypeSerializer,
    }),
  }),
};
